export const AGENT_RUN_WAITING_ON_PROPOSAL_TEXT =
    "Approve or decline the proposal to continue";

/**
 * Plain-English cause for a finish reason, shared by the run-end task comment
 * and the Agent panel tooltip. Reasons come from several backend sources, so
 * the key stays a string; unknown reasons get no copy.
 */
export const AGENT_RUN_FINISH_REASON_COPY: Record<string, string> = {
    activity_failed: "a step failed after retries",
    segment_failed: "a step failed after retries",
    budget_exhausted: "the run budget ran out",
    loop_detected: "the agent repeated the same change and was stopped",
    invocation_cap: "the agent made too many tool calls in one step",
    step_cap: "the agent ran out of steps for this stage",
    no_output: "the agent returned no result",
    no_progress: "the agent made no progress",
    persist_failed: "a change was made but couldn't be recorded",
    no_defaults: "the close defaults couldn't be worked out",
    no_package: "no close package was prepared",
};

export function agentRunFinishReasonCopy(
    reason: string | null | undefined,
): string | null {
    if (reason === null || reason === undefined) {
        return null;
    }
    return Object.hasOwn(AGENT_RUN_FINISH_REASON_COPY, reason)
        ? AGENT_RUN_FINISH_REASON_COPY[reason]
        : null;
}
